module.exports = __webpack_public_path__ + "static/media/01_quote_desktop.026e0866.jpg";